<template>
    <div class="w-full h-full" style="background-color: rgba(215, 215, 215, 0.11)">
        <div class="w-full mx-auto">
            <div
                v-for="trip in tripInfo"
                class="w-full flex py-0 flex-row"
            >
                <div class="h-full flex flex-col py-20 justify-center w-1/2 mt-0 px-14 2xl:ml-72">
                    <h1 class="text-4xl mb-5">
                        Planlagt i {{ trip.title }}
                    </h1>
                    <Accordion
                        v-for="day in days"
                        class="my-3"
                        @opened="setMarkers(day.times)"
                        @closed="resetMarkers"
                    >
                        <template #title>
                            <span class="text-3xl mb-4 md:text-xl hover:underline hover:success-dark">{{ day.day }}</span>
                        </template>
                        <template #content>
                            <div
                                v-for="time in day.times"
                                class="my-8"
                            >
                              <span @click="setMarkers([time], 15)" class="text-lg font-semibold cursor-pointer md:text-base md:font-normal hover:underline hover:success-dark">
                                {{ time.headline }}
                              </span>
                            </div>
                        </template>
                    </Accordion>
                </div>
                <div class="w-full md:w-1/2 h-full">
                    <GMapMap
                        v-for="trip in tripInfo"
                        :center="{ lat: center_lats, lng: center_lngs }"
                        :zoom="zoomCenter"
                        map-type-id="terrain"
                        style="width: 100%; height: 30rem"
                    >
                        <GMapMarker
                            :key="index"
                            v-for="(m, index) in markers"
                            :position="m.position"
                            :clickable="true"
                            :draggable="true"
                            @click="center = m.position"
                        />
                    </GMapMap>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Accordion from '@/ComponentsDeprecated/Accordion/Accordion';
import {computed, onMounted, ref} from "vue";

const tripInfo = [
    {
        title: 'Nice',
        alt: 'Map of Nice, France',
    },
];

const markers = ref([])
const zoom = ref(13)

const days = [
    {
        day: 'Spisesteder',
        times: [
            {
                headline: 'Le Rossini',
                position: {
                    lat: 43.70116,
                    lng: 7.25644,
                },
            },
            {
                headline: 'Bistrot Saint Georges',
                position: {
                    lat: 43.69547,
                    lng: 7.28647,
                },
            },
        ],
    },
    {
        day: 'Aktiviteter',
        times: [
            {
                headline: 'Castle of Nice',
                position: {
                    lat: 43.70019,
                    lng: 7.28338,
                },
            },
            {
                headline: 'Cimitière du Châteu',
                position: {
                    lat: 43.69813,
                    lng: 7.28078,
                },
            },
        ],
    },
    {
        day: 'Attraksjoner',
        times: [
            {
                headline: 'Fort du Mont Alban',
                position: {
                    lat: 43.70140,
                    lng: 7.30019,
                },
            },
            {
                headline: 'test2',
                position: {
                    lat: 43.68516,
                    lng: 7.21332
                }
            }
        ],
    },
    {
        day: 'Muligheter',
        times: [
            {
                headline: 'Avreise Monte Carlo',
                position: {
                    lat: 43.70580,
                    lng: 7.29041,
                },
            },
            {
                headline: 'test',
                position: {
                    lat: 43.75601,
                    lng: 7.21332
                }
            },
        ],
    },
];

onMounted(() => {
    resetMarkers()
})

function setMarkers(mrkrs, z = 14) {
    markers.value = mrkrs
    zoom.value = z
}

function resetMarkers() {
    let timeMarkers = []
    days.forEach((day) => {
        day.times.forEach((time) => {
            timeMarkers.push(time)
        })
    })
    markers.value = timeMarkers;
    zoom.value = 13
}

const center_lats = computed(() => {
    let lats = markers.value.map(a => a.position.lat)
    let latMax = Math.max(... lats)
    let latMin = Math.min(... lats)
    return (latMin+latMax)/2 || 0;
})

const center_lngs = computed(() => {
    let lngs = markers.value.map(a => a.position.lng)
    let lngMax = Math.max(... lngs)
    let lngMin = Math.min(... lngs)
    return (lngMin+lngMax)/2 || 0;
})

const zoomCenter = computed(() => {
    if (markers.value.length === 1) return 16
    let lngs = markers.value.map(a => a.position.lng)
    let lats = markers.value.map(a => a.position.lat)
    let lngMax = Math.max(... lngs)
    let lngMin = Math.min(... lngs)
    let latMax = Math.max(... lats)
    let latMin = Math.min(... lats)
    let max = Math.max(latMax-latMin, lngMax-lngMin)
    return (2.6-(max*2))*5

})
</script>
